















































































import {Component, Watch, Mixins, Vue} from 'vue-property-decorator'
import {$, IResource} from 'simpli-web-sdk'
import {AppConfig} from '@/config/app.config'
import {MixinFilter} from '@/components/mixins/MixinFilter'
import {MixinSelect} from '@/components/mixins/MixinSelect'
import FilterDelivery from '@/components/filters/FilterDelivery.vue'
import ModalDeliveryEnd from '@/components/modals/ModalDeliveryEnd.vue'
import ModalDeliveryRemove from '@/components/modals/ModalDeliveryRemove.vue'
import {DeliveryStatus} from '@/enums/DeliveryStatus'
import DeliveryRequest from '@/model/request/DeliveryRequest'
import CargaCollection from '@/model/collection/CargaCollection'
import Carga from '@/model/resource/Carga'
import FilterToggle from '@/components/FilterToggle.vue'
import {Getter} from 'vuex-class'
import Responsavel from '@/model/resource/Responsavel'

const metaInfo = () => ({
  title: $.t('view.manage.deliveryEnd.title'),
})

@Component({
  metaInfo,
  components: {FilterToggle, FilterDelivery, ModalDeliveryEnd, ModalDeliveryRemove},
})
export default class ManageDeliveryEndView extends Mixins(MixinFilter, MixinSelect) {
  @Getter('auth/responsavel') user!: Responsavel

  AppConfig = AppConfig

  filter = new DeliveryRequest()
  collection = new CargaCollection(this.filter)

  selectedItems: Carga[] = []

  openModalDeliveryEnd(items?: Carga[]) {
    const selectedItems = items || this.selectedItems
    this.$modal.open('deliveryEnd', selectedItems)
  }

  openModalDeliveryRemove(items?: Carga[]) {
    const selectedItems = items || this.selectedItems
    this.$modal.open('deliveryRemove', selectedItems)
  }

  async refresh() {
    this.selectedResource = {}
    this.selectedItems = []
    await this.query()
  }

  created() {
    if (this.$route.query.start === undefined) {
      this.filter.startDate = DeliveryRequest.defaultStartOfDay()
    }

    this.filter.status = `${DeliveryStatus.PENDING}`
    this.filter.event = null

    this.collection.orderBy = 'dataCriacao'
    this.collection.asc = false
  }
}
